import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import axios from 'axios';
import CpfInput from '../../components/external/CpfInput';
import DataNascimentoInput from '../../components/external/DataNascimentoInput';
import Modal from '../../components/external/Modal';
import '../../styles/external/App.css';
import { useEnvValue } from '../../config/env';

export default function Cadastro() {
  const SITE_KEY = useEnvValue('REACT_APP_RECAPTCHA_SITE_KEY');
  const API_BASE_URL = useEnvValue('REACT_APP_URL_API');
  const [cpf, setCpf] = useState('');
  const [dataNascimento, setDataNascimento] = useState('');
  const [captchaToken, setCaptchaToken] = useState(null);
  const [modalData, setModalData] = useState({ show: false, title: '', message: '' });
  const [formIncompleto, setFormIncompleto] = useState(false);

  const navigate = useNavigate();

  const isFormValido = () => {
    return cpf.trim() !== '' && dataNascimento.trim() !== '';
  };

  const handleEnviarToken = async (e) => {
    e.preventDefault();

    if (!isFormValido()) {
      setFormIncompleto(true);
      return;
    }

    // if (!captchaToken) {
    //   setModalData({
    //     show: true,
    //     title: 'Validação reCAPTCHA',
    //     message: 'Por favor, confirme o reCAPTCHA.'
    //   });
    //   return;
    // }

    try {
      const csrf = await axios.get(
        `${API_BASE_URL}/csrf/token`,
        {
          withCredentials: true,
        }
      );

      const csrfToken = csrf.data?.csrfToken;

      const authResponse = await axios.post(
        `${API_BASE_URL}/auth/token`,
        { tipo: 'INTEGRACAO' },
        {
          headers: {
            'X-CSRF-Token': csrfToken,
          },
          withCredentials: true,
        },
      );

      const token = authResponse.data?.access_token;
      if (!token) {
        throw new Error('Token de autenticação não obtido.');
      }

      const result = await axios.post(
        `${API_BASE_URL}/notas/validar-cliente`,
        {
          cpf: cpf,
          dataNascimento: dataNascimento
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-CSRF-Token': csrfToken,
          },
          withCredentials: true,
        }
      );

      localStorage.setItem('csrf', csrfToken);
      localStorage.setItem('jwt', token);
      localStorage.setItem('cpf', cpf);
      localStorage.setItem('dataNascimento', dataNascimento);

      navigate('/autenticacao');
    } catch (error) {
      const mensagemErro = error.response?.data?.message || 'Erro ao validar os dados. Verifique CPF e Data de Nascimento.';

      console.error('Erro na validação do cliente:', error);
      setModalData({
        show: true,
        title: 'Erro ao validar dados',
        message: mensagemErro
      });
    }
  };

  return (
    <div className="container">
      <Modal
        show={modalData.show}
        title={modalData.title}
        message={modalData.message}
        onClose={() => setModalData({ ...modalData, show: false })}
      />

      <div className="left">
        <h1>Preencha os dados para criar sua conta</h1>

        <form className="form" onSubmit={handleEnviarToken}>
          <CpfInput
            value={cpf}
            onChange={(e) => {
              setCpf(e.target.value);
              setFormIncompleto(false);
            }}
          />
          <DataNascimentoInput
            value={dataNascimento}
            onChange={(e) => {
              setDataNascimento(e.target.value);
              setFormIncompleto(false);
            }}
          />

          {formIncompleto && (
            <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
              Por favor, preencha todos os campos.
            </div>
          )}

          {/* <div style={{ marginTop: '10px', marginBottom: '10px' }}>
            <ReCAPTCHA
              sitekey={SITE_KEY}
              onChange={(token) => setCaptchaToken(token)}
            />
          </div> */}

          <button
            type="submit"
            className="button"
            disabled={!isFormValido()}
            style={{
              marginTop: '15px',
              opacity: !isFormValido() ? 0.5 : 1,
              cursor: !isFormValido() ? 'not-allowed' : 'pointer'
            }}
          >
            Enviar Token
          </button>
        </form>
      </div>
    </div>
  );
}
